import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import { useEffect } from 'react';
import Layout from './components/layout/Layout';
import Home from './pages/home/Home';
import Posts from './pages/Posts';
import PostDetail from './features/posts/PostDetail';

import Publications from './pages/Publications';
import PublicationDetail from './features/publications/PublicationDetail'

import Magazines from './pages/Magazines';
import MagazineDetail from './features/magazines/MagazineDetail'




import Directorates from './pages/Directorates';
import Directorate from './features/directorates/Directorate';


import Symposiums from './pages/Symposiums';


import Symposium from './features/symposium/Symposium';

import AboutUs from './pages/aboutus/AboutUs';
import Contact from './pages/contact/Contact'

import Guide from './pages/corporate/guide/Guide';
import VisionMission from './pages/corporate/visionmission/VisionMission';
import President from './pages/corporate/president/President';
import Directors from './pages/corporate/directors/Directors';



import NotFound from './pages/NotFound';

import ScrollToTop from './hooks/ScrollToTop';

import { useStrapiConstants, StrapiConstantsProvider } from "./contexts/StrapiConstantsContext";
import Loading from './components/common/Loading';
import ErrorMessage from './components/common/ErrorMessage';
import { APP_VERSION } from "./version";

import './App.css';





function AppContent() {
  // useEffect(() => {
  //   loadStrapiConstants(); // Loads once, globally
  // }, []);


  ReactGA.initialize("G-YYV582RWTS");
  function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    }, [location]);

    return null;
  }

  function checkAppVersion() {
    const savedVersion = localStorage.getItem("app_version");

    if (savedVersion !== APP_VERSION) {
      // Clear all cached data
      localStorage.clear();

      // Save the new version
      localStorage.setItem("app_version", APP_VERSION);
    }
  }

  checkAppVersion();




  const { loaded, error } = useStrapiConstants(); // Consume the context
  if (error) {
    // Handle critical loading error, perhaps show an error message
    return <ErrorMessage />;
  }

  if (!loaded) {
    // Show a full-screen loading spinner while constants are fetched
    return <Loading />;
  }
  return (
    <Router>
      <AnalyticsTracker />

      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />

          {/* Sempozyumlar Routes */}
          <Route path="sempozyumlar" element={<Symposiums />} />
          <Route path="sempozyumlar/:slug" element={<Symposium />} />

          {/* Kurumsal Routes */}
          <Route path="kurumsal/kurumsal-kimlik-rehberi" element={<Guide />} />
          <Route path="kurumsal/misyon-vizyon" element={<VisionMission />} />
          <Route path="kurumsal/baskan" element={<President />} />
          <Route path="kurumsal/yonetim-kurulu" element={<Directors />} />



          {/* Basın Routes */}
          <Route path="basin/haberler" element={<Posts />} />
          <Route path="basin/haberler/:slug" element={<PostDetail />} />


          <Route path="basin/yayinlar" element={<Publications />} />
          <Route path="basin/yayinlar/:slug" element={<PublicationDetail />} />

          <Route path="basin/dergiler" element={<Magazines />} />
          <Route path="basin/dergiler/:slug" element={<MagazineDetail />} />

          {/* Directorate */}
          <Route path="direktorlukler" element={<Directorates />} />
          <Route path="direktorlukler/:slug" element={<Directorate />} />





          {/* Neler Yapıyoruz Routes */}
          {/* <Route path="neler-yapiyoruz/projeler" element={<AboutUs />} />
          <Route path="neler-yapiyoruz/etkinlikler" element={<Posts />} />
          <Route path="neler-yapiyoruz/hizmetler" element={<Posts />} /> */}


          {/* Other Routes */}
          <Route path="iletisim" element={<Contact />} />
          {/* <Route path="posts" element={<Posts />} />
          <Route path="posts/:documentId" element={<PostDetail />} /> */}

          {/* <Route path="publications" element={<Publications />} />
          <Route path="publications/:slug" element={<PublicationDetail />} /> */}

          {/* <Route path="about" element={<AboutUs />} /> */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}
function App() {
  // No more useEffect for data fetching!
  return (
    <StrapiConstantsProvider>
      <AppContent />
    </StrapiConstantsProvider>
  )
}
export default App;